import _ from 'lodash'

export default {
    set (key, value) {
        try {
            localStorage.setItem(
                `rentora:${key}`,
                _.isObject(value) ? JSON.stringify(value) : value
            )

            return true
        } catch (e) {
            return false
        }
    },

    get (key) {
        try {
            const value = localStorage.getItem(`rentora:${key}`)

            try {
                return JSON.parse(value)
            } catch (e) {
                return value
            }
        } catch (e) {
            return null
        }
    },

    remove (key) {
        try {
            localStorage.removeItem(`rentora:${key}`)
            return true
        } catch (e) {
            return false
        }
    }
}
